import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable, map } from 'rxjs';

import { LIST_MESSAGES_BY_ROOM } from '@graphql/queries/messages.queries';
import { ROOM_MESSAGE_CREATED_SUBSCRIPTION } from '@graphql/subscriptions/messages.subscriptions';

import {
  IListMessagesByRoomInput,
  IListMessagesByRoomResult,
  ISubscriptionRoomMessageCreatedRes,
} from '@shared/models/messages';

@Injectable({
  providedIn: 'root',
})
export class MessagesService {
  constructor(private apollo: Apollo) {}

  listMessagesByRoom(
    input: IListMessagesByRoomInput
  ): Observable<IListMessagesByRoomResult> {
    return this.apollo
      .query({ query: LIST_MESSAGES_BY_ROOM, variables: input })
      .pipe(map((result) => result.data as IListMessagesByRoomResult));
  }

  subscribeToRoomMessageCreated(): Observable<ISubscriptionRoomMessageCreatedRes> {
    return this.apollo
      .subscribe<{ roomMessageCreated: ISubscriptionRoomMessageCreatedRes }>({
        query: ROOM_MESSAGE_CREATED_SUBSCRIPTION,
      })
      .pipe(
        map(
          (result) =>
            result.data
              ?.roomMessageCreated as ISubscriptionRoomMessageCreatedRes
        )
      );
  }
}
